// extracted by mini-css-extract-plugin
export default {"action":"MunicipalityActions_action__aVRCG","back":"MunicipalityActions_back__jbpMr","buttons":"MunicipalityActions_buttons__bmMrj"};